import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6fb37a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "roles" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-wrap text-truncate" }, "Digital Signage Roles", -1))
const _hoisted_4 = { class: "dt-container" }
const _hoisted_5 = {
  key: 0,
  class: "text-center my-5"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "You haven't added any roles yet.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Create new roles and add members to enable digital signage management in selected Ditto rooms. Admin and User are system roles with access to all Ditto rooms. "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "link",
    href: "https://airsquirrels.com/ditto/help/roles",
    target: "_blank",
    rel: "noreferrer noopener"
  }, "Learn more about Roles"),
  /*#__PURE__*/_createTextVNode(".")
], -1))
const _hoisted_8 = { class: "inventory-table__actions d-flex flex-column flex-sm-row align-items-sm-end mb-4" }
const _hoisted_9 = { class: "ms-sm-auto mt-4 mt-sm-0" }
const _hoisted_10 = { class: "px-1" }
const _hoisted_11 = { class: "d-flex flex-row mb-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Role Name: ", -1))
const _hoisted_13 = { class: "expanded-table__description" }
const _hoisted_14 = {
  class: "icon--small icon--white",
  viewBox: "0 0 24 24"
}
const _hoisted_15 = ["d"]
const _hoisted_16 = { class: "d-flex" }
const _hoisted_17 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`ms-auto align-self-center receiver-status__badge__mobile`),
  "aria-hidden": "true"
}
const _hoisted_18 = { class: "d-flex" }
const _hoisted_19 = {
  class: "icon--small icon--white",
  viewBox: "0 0 24 24"
}
const _hoisted_20 = ["d"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_TierLimit = _resolveComponent("TierLimit")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, { to: "/roles/new" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { type: "primary" }, {
            default: _withCtx(() => [
              _createTextVNode("New Role")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.roles && _ctx.roles.length == 0 && !_ctx.viewLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_button, {
              class: "px-5 py-3",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Add Your First Role")
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_input, {
                  placeholder: "Search Roles",
                  modelValue: _ctx.rolesSearchFilter,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rolesSearchFilter) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createVNode(_component_el_table, {
              "empty-text": _ctx.rolesSearchFilter ? 'No roles match search' : 'You have not created any roles',
              data: _ctx.filteredRoles,
              ref: "multipleTable"
            }, {
              default: _withCtx(() => [
                (_ctx.windowWidth.value < 576)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      type: "expand",
                      width: "55"
                    }, {
                      default: _withCtx((props) => [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("div", _hoisted_13, _toDisplayString(props.row.name), 1)
                          ]),
                          _createVNode(_component_el_tooltip, {
                            effect: "dark",
                            content: (props.row.readOnly) ? `${ props.row.name } is a system role and cannot be deleted`: 'Roles with active members cannot be deleted',
                            placement: "top",
                            disabled: !(props.row.readOnly) && props.row.members.length < 1,
                            "hide-after": 0,
                            "show-after": 100
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                class: _normalizeClass([{'is-disabled' : props.row.members.length}, "mt-4 mb-3 el-table-row__delete-button el-table-row__delete-button--mobile"]),
                                type: "danger",
                                id: props.row.id,
                                onClick: ($event: any) => (_ctx.onDeleteRole(props.row)),
                                circle: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_14, [
                                    _createElementVNode("path", { d: _ctx.mdiDelete }, null, 8, _hoisted_15)
                                  ]))
                                ]),
                                _: 2
                              }, 1032, ["class", "id", "onClick"])
                            ]),
                            _: 2
                          }, 1032, ["content", "disabled"])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "Role Name",
                  sortable: ""
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_router_link, {
                        class: "el-table-column__name me-1 me-sm-0",
                        to: `/roles/${scope.row.id }`
                      }, {
                        default: _withCtx(() => [
                          (scope.row.name.toLowerCase() == 'admin' || scope.row.name.toLowerCase() == 'user')
                            ? (_openBlock(), _createBlock(_component_Icon, {
                                key: 0,
                                class: "me-1",
                                style: _normalizeStyle({ fill: scope.row.color }),
                                icon: _ctx.mdiShieldLock
                              }, null, 8, ["style", "icon"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(scope.row.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      (_ctx.windowWidth.value < 576 && scope.row.name && scope.row.name.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "members",
                  label: "Members",
                  sortable: ""
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: "View members",
                        placement: "top",
                        "hide-after": 0,
                        "show-after": 100
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            class: "me-1 me-sm-0",
                            to: `/roles/${ scope.row.id }#members`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(scope.row.members.length), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.windowWidth.value >= 576)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 1,
                      prop: "id",
                      "class-name": "el-table-row__delete"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_tooltip, {
                          effect: "dark",
                          content: (scope.row.readOnly) ? `${ scope.row.name } is a system role and cannot be deleted`: 'You cannot delete a role with active members',
                          placement: "top",
                          disabled: !(scope.row.readOnly) && scope.row.members.length < 1,
                          "hide-after": 0,
                          "show-after": 100
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              class: _normalizeClass([{'is-disabled' : scope.row.readOnly || scope.row.members.length}, "el-table-row__delete-button"]),
                              type: "danger",
                              onClick: ($event: any) => (_ctx.onDeleteRole(scope.row)),
                              id: scope.row.id,
                              circle: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock("svg", _hoisted_19, [
                                  _createElementVNode("path", { d: _ctx.mdiDelete }, null, 8, _hoisted_20)
                                ]))
                              ]),
                              _: 2
                            }, 1032, ["class", "onClick", "id"])
                          ]),
                          _: 2
                        }, 1032, ["content", "disabled"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["empty-text", "data"])
          ], 64))
    ]),
    _createVNode(_component_TierLimit, {
      modelValue: _ctx.showTierCallout,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showTierCallout) = $event)),
      isCallout: false,
      isLimit: false,
      message: "Upgrade your Ditto account to unlock roles."
    }, null, 8, ["modelValue"])
  ])), [
    [_directive_loading, _ctx.isLoading]
  ])
}